import clsx from 'clsx';
import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import isFutureDate from '@smart-tv/utils/date/is-future-date';

import { Props } from './content-item';
import ContentItemLogo from './content-item-logo';
import ContentItemImage from './content-item-image';
import ContentItemStartTime from './content-item-start-time';
import ContentItemProgressBar from './content-item-progress-bar';
import ContentItemRecordingAnimation from './content-item-recording-animation';
import styles from './content-item.module.scss';

export const ContentItemDefaultContent: React.FC<Props> = (props: Props) => {
  const {
    contentItem,
    showProgress = true,
    showStartTime = true,
    focused = false,
    isUnavailable,
    animating,
    setAnimating
  } = props;

  const { logo, cover, coverType, startTime, endTime, contentLayout } = contentItem;
  const hasProgress = showProgress && startTime && endTime && !isFutureDate(startTime);

  return (
    <ContentItemImage
      cover={cover}
      coverType={coverType}
      futureContent={startTime ? isFutureDate(startTime) : false}
      liveTV={false}
      focused={focused}
      animating={animating}
      setAnimating={setAnimating}
      contentLayout={contentLayout}
      $isUnavailable={isUnavailable}
    >
      {logo && <ContentItemLogo src={logo} data-testid={testIds.contentItem.logo} />}

      <ContentItemRecordingAnimation
        className={clsx(styles['content-item__recording'], {
          [styles['content-item__recording--without-progress']]: !hasProgress
        })}
        contentItem={contentItem}
      />

      {hasProgress && (
        <ContentItemProgressBar liveTV={false} startTime={startTime} endTime={endTime} />
      )}

      {showStartTime && startTime && isFutureDate(startTime) && (
        <ContentItemStartTime startTime={startTime} />
      )}
    </ContentItemImage>
  );
};

export default ContentItemDefaultContent;
